import "../../App.css";
import Sidebar from "../../components/Sidebar";
import "../../styles/login.css";
import { withRouter } from "react-router-dom";
import React, { useState, useEffect } from "react";
import UserTab from "../UserTab";
import Table from "../Table";
import CurrentUser from "../CurrentUser";
import Parametros from "../Parametros";
import EliminarElemento from "../EliminarElemento";
import EmptyTableRow from "../EmptyTableRow";

const INITIAL_FORM_STATE = { name: "" };
const INITIAL_PAGINATION_STATE = {
  limit: 5,
  skip: 1,
};

function Clientes(props) {
  const [paginacionState, setPaginacionState] = useState(
    INITIAL_PAGINATION_STATE
  );
  const [paginas, setPaginas] = useState(0);
  const [usuario] = useState(CurrentUser.user);
  const [update, setUpdate] = useState(true);
  const [data, setData] = useState([]);
  const [editable, setEditable] = useState(null);
  const [busqueda, setBusqueda] = useState(INITIAL_FORM_STATE);
  const [updatePagination, setUpdatePagination] = useState(true);

  useEffect(() => {
    let url = `${Parametros.urlApi}clients/paginated?skip=${paginacionState.skip}&limit=${paginacionState.limit}`;
    for (const key in busqueda) {
      if (busqueda[key].trim() !== "") {
        url += `&${key}=${busqueda[key]}`;
      }
    }
    fetch(url, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + usuario.key,
        Accept: "application/json",
        "Content-Type": "application/json",
        Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Error al cargar clientes");
        return res.json();
      })
      .then((data) => {
        setData(data.data);
        setPaginas(data.n_pages);
      })
      .catch((error) => console.error(error));
  }, [usuario.key, paginacionState, update]);

  const handleChangeBusqueda = (e) => {
    setBusqueda({
      ...busqueda,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeUpdate = (e) => {
    setEditable({
      ...editable,
      [e.target.name]: e.target.value,
    });
  };

  const handleConfirmEditar = () => {
    if (usuario.permisos.indexOf("Editar") > -1) {
      if (window.confirm("¿Esta seguro que deseas editar este elemento?")) {
        fetch(Parametros.urlApi + "client/" + editable.client_id, {
          method: "PUT",
          headers: {
            Authorization: "Bearer " + usuario.key,
            Accept: "application/json",
            "Content-Type": "application/json",
            Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
          },
          body: JSON.stringify(editable),
        })
          .then((res) => res.json())
          .then((data) => {
            alert(data.message || data.detail);
            setUpdate(!update);
            setEditable(null);
          })
          .catch((error) => {
            console.error(error);
            alert("Error al editar el cliente");
          });
      }
    } else {
      console.log(usuario.editar);
    }
  };

  const handleCancelEditar = () => {
    setEditable(null);
  };

  const handleEditar = (item) => {
    setEditable(item);
  };

  const handleAgregarPrompt = () => {
    if (usuario.permisos.indexOf("Crear") <= -1) {
      console.log(usuario.crear);
      return;
    }
    const nombre = window.prompt("Nombre del nuevo cliente:");
    if (!nombre || !nombre.trim()) return;
    if (!window.confirm("¿Esta seguro que deseas agregar este elemento?")) return;
    fetch(Parametros.urlApi + "client", {
      method: "POST",
      headers: {
        Authorization: "Bearer " + usuario.key,
        Accept: "application/json",
        "Content-Type": "application/json",
        Origin: "https://d1tl5p9wrfnj29.cloudfront.net/",
      },
      body: JSON.stringify({ name: nombre.trim() }),
    })
      .then((res) => res.json())
      .then((data) => {
        alert(data.message || data.detail);
        setUpdate(!update);
      })
      .catch((error) => {
        console.error(error);
        alert("Error al crear el cliente");
      });
  };

  return (
    <div className="App">
      <Sidebar tipo="2"></Sidebar>
      <br />
      <UserTab nombre={"Clientes"}></UserTab>
      <div className="container">
        <div className="col-md-12 table-responsive">
          <Table
            key={updatePagination}
            type={1}
            paginas={paginas}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
            paginationBelow={true}
            extraAction={
              <button
                type="button"
                onClick={handleAgregarPrompt}
                className="btn btn-primary traspasarDeudasBtn"
              >
                Agregar
              </button>
            }
            elementos={["Nombre"]}
          ></Table>
        </div>
        <div
          className="col-md-12 table-responsive"
          style={{ height: 300, width: "100%" }}
        >
          <table className="table table-bordered" id="myTable">
            <Table type={2} elementos={["Nombre"]}></Table>

            {usuario.permisos.indexOf("Ver") > -1 ? (
              <tbody className="ajusteTabladata">
                {(!data || data.length === 0) && (
                  <EmptyTableRow colSpan={20} />
                )}
                {data?.map((item, index) => {
                  return (
                    <tr key={item.client_id}>
                      {editable?.client_id === item.client_id ? (
                        <>
                          <td>{item.client_id}</td>
                          <td>
                            <input
                              value={editable.name}
                              name="name"
                              onChange={handleChangeUpdate}
                              className="form-control"
                            ></input>
                          </td>
                          <td>
                            <abbr title="Confirmar Edición">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  handleConfirmEditar(item);
                                }}
                                className="glyphicon glyphicon glyphicon-ok"
                              ></span>
                            </abbr>
                            <abbr title="Cancelar Edición">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  handleCancelEditar(item);
                                }}
                                className="glyphicon glyphicon-share-alt"
                              ></span>
                            </abbr>
                          </td>
                        </>
                      ) : (
                        <>
                          <td>{item.client_id}</td>
                          <td>{item.name}</td>
                          <td>
                            <abbr title="Editar Elemento">
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  handleEditar(item);
                                }}
                                className="glyphicon glyphicon-pencil"
                              ></span>
                            </abbr>
                            <EliminarElemento
                              endpoint={`client/${item.client_id}`}
                              onSuccess={() => {
                                setUpdate(!update);
                              }}
                            />
                          </td>
                        </>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            ) : (
              <tbody>
                <td>{usuario.ver}</td>
              </tbody>
            )}
          </table>
          <Table
            type={3}
            paginas={paginas}
            paginadorState={paginacionState}
            setPaginadoor={setPaginacionState}
          />
          {!usuario.permisos.indexOf("Ver") < -1 && usuario.ver}
        </div>
      </div>
    </div>
  );
}

export default withRouter(Clientes);
